import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import { useRef, useState } from 'react';
import CompA from './CompA';
import CompB from './CompB';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct');
    const itemsA = [
        {
            tabValue: 'a1',
            tabLabel: t('O_tab1'),
        },
        {
            tabValue: 'a2',
            tabLabel: t('O_tab2'),
        },
    ];
    const defaultKey = 'a1';
    const [tabKey, setTabKey] = useState(defaultKey);
    const targetRef = useRef<HTMLDivElement>(null);
    const tabChange = (item: any) => {
        setTimeout(() => {
            if (targetRef.current) {
                targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 10);
        setTabKey(item.tabValue);
    };
    return (
        <div className={styles.comp} id="WhatInBoxA" ref={targetRef}>
            <EcoSpace />
            <EcoSectionCommon title={t('O_title')} />
            <EcoSpaceSmall />
            {tabKey === 'a1' && (
                <>
                    <CompA />
                </>
            )}
            {tabKey === 'a2' && (
                <>
                    <CompB />
                </>
            )}
            <EcoTab items={itemsA} activeKey={defaultKey} onChange={tabChange} />
        </div>
    );
}
